import { map, filter } from 'lodash';
import { createSlice } from '@reduxjs/toolkit';
// import axios from '../../utils/axios';
import axios from 'axios';
import urls from '../../url/urls';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  myProfile: null,
  posts: [],
  pbi: [],
  pbiList: [],
  followers: [],
  friends: [],
  gallery: [],
  cards: null,
  addressBook: [],
  invoices: [],
  notifications: null
};

const slice = createSlice({
  name: 'pbi',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET POSTS
    getPostsSuccess(state, action) {
      state.isLoading = false;
      state.posts = action.payload;
    },

    // GET pbiS
    getpbisSuccess(state, action) {
      state.isLoading = false;
      state = action.payload;
    },

    // DELETE pbiS
    deletepbiSuccess(state, action) {
      state.isLoading = false;
      console.log(JSON.stringify(action));
      // const deleteUser = filter(state.pbiList, (pbi) => pbi.id !== action.payload);
      state.pbiList = action.payload;
    },

    deletepbidata(state, action) {
      console.log('id nya : ');
      console.log(action.payload);

      deletepbi(action.payload);
      // const deleteUser = filter(state.pbiList, (pbi) => pbi.id !== action.payload);
      // state.pbiList = deleteUser;
    },

    // GET FOLLOWERS
    getFollowersSuccess(state, action) {
      state.isLoading = false;
      state.followers = action.payload;
    },

    // ON TOGGLE FOLLOW
    onToggleFollow(state, action) {
      const followerId = action.payload;

      const handleToggle = map(state.followers, (follower) => {
        if (follower.id === followerId) {
          return {
            ...follower,
            isFollowed: !follower.isFollowed
          };
        }
        return follower;
      });

      state.followers = handleToggle;
    },

    // GET FRIENDS
    getFriendsSuccess(state, action) {
      state.isLoading = false;
      state.friends = action.payload;
    },

    // GET GALLERY
    getGallerySuccess(state, action) {
      state.isLoading = false;
      state.gallery = action.payload;
    },

    // GET MANAGE pbiS
    getpbiListSuccess(state, action) {
      state.isLoading = false;
      state.pbiList = action.payload;
    },

    // GET CARDS
    getCardsSuccess(state, action) {
      state.isLoading = false;
      state.cards = action.payload;
    },

    // GET ADDRESS BOOK
    getAddressBookSuccess(state, action) {
      state.isLoading = false;
      state.addressBook = action.payload;
    },

    // GET INVOICES
    getInvoicesSuccess(state, action) {
      state.isLoading = false;
      state.invoices = action.payload;
    },

    // GET NOTIFICATIONS
    getNotificationsSuccess(state, action) {
      state.isLoading = false;
      state.notifications = action.payload;
    }
  }
});

// Reducer
export default slice.reducer;

// Actions
export const { onToggleFollow, deletepbidata } = slice.actions;

// ----------------------------------------------------------------------

export function getProfile() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/pbi/profile');
      dispatch(slice.actions.getProfileSuccess(response.data.profile));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getPosts(values, Filedoc) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      console.log(JSON.stringify('Nilai Values : '));
      console.log(JSON.stringify(values));
      let response = null;
      if (values.file === '') {
        response = await axios.post(urls.pbi, values);
      } else {
        const formData = new FormData();
        formData.append('file', Filedoc);
        formData.append('id', values.id === '' ? null : values.id);
        formData.append('title', values.title);
        formData.append('description', values.description);
        formData.append('types', values.types);
        formData.append('createdby', values.createdby);
        response = await axios.post(urls.pbi, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
      }
      console.log(JSON.stringify(response));
      console.log(JSON.stringify(response.data));
      dispatch(slice.actions.getPostsSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getFollowers() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/pbi/social/followers');
      dispatch(slice.actions.getFollowersSuccess(response.data.followers));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getFriends() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/pbi/social/friends');
      dispatch(slice.actions.getFriendsSuccess(response.data.friends));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getGallery() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/pbi/social/gallery');
      dispatch(slice.actions.getGallerySuccess(response.data.gallery));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getpbiList(x) {
  return async (dispatch) => {
    const url = `${urls.pbi}/${x}`;
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(url);

      dispatch(slice.actions.getpbiListSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function deletepbi(x, y) {
  return async (dispatch) => {
    console.log('Proses Delete');
    const url = `${urls.bmpp}/delete/${x}`;
    const urlss = `${urls.pbi}/${y}`;
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(url);
      const responses = await axios.get(urlss);

      dispatch(slice.actions.deletepbiSuccess(responses.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getCards() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/pbi/account/cards');
      dispatch(slice.actions.getCardsSuccess(response.data.cards));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getAddressBook() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/pbi/account/address-book');
      dispatch(slice.actions.getAddressBookSuccess(response.data.addressBook));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getInvoices() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/pbi/account/invoices');
      dispatch(slice.actions.getInvoicesSuccess(response.data.invoices));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getNotifications() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/pbi/account/notifications-settings');
      dispatch(slice.actions.getNotificationsSuccess(response.data.notifications));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getpbis() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/pbi/all');
      dispatch(slice.actions.getpbisSuccess(response.data.pbis));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
